// Correct: Import React from 'react'
import * as React from 'react';

import {Dimensions, Platform, PixelRatio} from 'react-native';
import dayjs from 'dayjs';

import Color from '../theme/Color';
import ColorMappings from './colorMappings';
import RenderImage from './RenderImage';
const {width: SCREEN_WIDTH, height: SCREEN_HEIGHT} = Dimensions.get('window');
// based on iphone X's scale
let NEW_SCREEN_WIDTH =
  SCREEN_WIDTH > SCREEN_HEIGHT ? SCREEN_HEIGHT : SCREEN_WIDTH;
const scale = NEW_SCREEN_WIDTH / 375;

// const ICON_SHAPE = {
//   CIRCLE_IMG: 'circle-img',
// };

const imageTypes: any = [
  'bmp',
  'dds',
  'gif',
  'heic',
  'jpg',
  'png',
  'psd',
  'pspimage',
  'tga',
  'thm',
  'tif',
  'tiff',
  'yuv',
  'jpeg',
];
const videoTypes: any = [
  '3g2',
  '3gp',
  'asf',
  'avi',
  'flv',
  'm4v',
  'mov',
  'mp4',
  'mpg',
  'rm',
  'srt',
  'swf',
  'vob',
  'wmv',
];

export const renderImage: React.FC<any> = ({
  image,
  iconShape = undefined,
  iconSize = '',
  width = 10,
  height = 10,
}) => {
  return (
    <RenderImage
      image={image}
      iconShape={iconShape}
      iconSize={iconSize}
      width={width}
      height={height}
    />
  );
};

export function createDateRange(start: any, end: any) {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  let currentDate = startDate;
  const dateArray: any = [];

  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
    dateArray.push(currentDate.toDate());
    currentDate = currentDate.add(1, 'day');
  }
  //console.log('dateArray   ---->:', dateArray);
  return dateArray;
}

function padZero(str: any, len?: any) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function invertColor(hex: any, bw?: boolean) {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }

  if (hex.length !== 6) {
    const hexValue = ColorMappings[hex?.toLowerCase()];

    if (!hexValue) {
      //throw new Error('Invalid HEX color to invertColor :' + hex);
      return Color.black;
    }

    hex = hexValue;
  }
  if (!hex) {
    return undefined;
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  var r: any = parseInt(hex.slice(0, 2), 16),
    g: any = parseInt(hex.slice(2, 4), 16),
    b: any = parseInt(hex.slice(4, 6), 16);

  //console.log('   ====>:', finalResultColor);
  if (hex?.toLowerCase() === '#000000') {
    return '#FFFFFF';
  }

  if (hex?.toLowerCase() === '#ffffff') {
    return '#000000';
  }

  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  let finalResultColor = '#' + padZero(r) + padZero(g) + padZero(b);
  // console.log(' finalResultColor  ====>:', finalResultColor);
  return finalResultColor;
}

export function normalize(size: number) {
  const newSize = size * scale;
  if (Platform.OS === 'ios') {
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
  } else {
    return Math.ceil(PixelRatio.roundToNearestPixel(newSize));
  }
}

export function generateColor() {
  const randomColor = Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, '0');
  return `#${randomColor}`;
}

// function getScale() {
//   if (Platform.OS === 'ios') {
//     let NEW_SCREEN_WIDTH =
//       SCREEN_WIDTH > SCREEN_HEIGHT ? SCREEN_HEIGHT : SCREEN_WIDTH;
//     return NEW_SCREEN_WIDTH / 375;
//   } else {
//     return 1080 / 1920;
//   }
// }

export function isSameDay(
  currentMessage: {createdOn: number} | any,
  diffMessage: {createdOn: number} | any,
) {
  const currentCreatedAt = dayjs(currentMessage.createdOn);
  const diffCreatedAt = dayjs(diffMessage.createdOn);
  if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
    return false;
  }
  return currentCreatedAt.isSame(diffCreatedAt, 'day');
}

export function isSameUser(
  currentMessage: {user: {_id: string}} | any,
  diffMessage: {user: {_id: string}} | any,
) {
  return !!(
    diffMessage?.user &&
    currentMessage?.user &&
    diffMessage.user._id === currentMessage.user._id
  );
}

export const getItemId = (pattern?: any) => {
  var _pattern = pattern || 'xyxxyxxy';
  _pattern = _pattern.replace(/[xy]/g, function (c: any) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  return _pattern;
};

export function getDrawableByExt(ext: string): string {
  if (imageTypes.includes(ext)) {
    return '&#128247;';
  } else if (videoTypes.includes(ext)) {
    return '&#127909;';
  } else {
    return '&#128195;';
  }
}
